var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticStyle: { "margin-bottom": "40px", "text-align": "center" },
          attrs: { "align-h": "center" }
        },
        [
          _vm.buyFor === "self"
            ? _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c("font-awesome-icon", {
                    staticClass: "text-success my-auto success-icon",
                    attrs: { icon: ["fas", "check-circle"] }
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "font-weight-bolder mt-3" }, [
                    _vm._v("Payment Successful!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "55px" } }, [
                    _vm._v(_vm._s(_vm.msgCredit))
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Your credits now is ")]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    { staticClass: "mb-4 font-weight-bolder credit-text" },
                    [_vm._v(_vm._s(_vm.lastCredit))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-block",
                      attrs: {
                        href: _vm.getFromApps
                          ? "musicverse://transaction_done"
                          : "/#/home"
                      }
                    },
                    [_vm._v("Continue")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.buyFor === "other"
            ? _c(
                "b-col",
                { attrs: { cols: "12", md: "5" } },
                [
                  _c("font-awesome-icon", {
                    staticClass: "text-success my-auto success-icon",
                    attrs: { icon: ["fas", "check-circle"] }
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "font-weight-bolder mt-3" }, [
                    _vm._v("Thank you for purchasing!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "29px" } }, [
                    _vm._v(_vm._s(_vm.msgCredit))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-1" }, [
                    _vm._v("Here’s  your redemption code")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "position-relative" }, [
                    _c(
                      "h1",
                      { staticClass: "mb-4 font-weight-bolder credit-text" },
                      [_vm._v(_vm._s(_vm.redemptionCode))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "d-flex position-absolute cursor-pointer copy-icon-link",
                        on: { click: _vm.copyRedemptionCode }
                      },
                      [
                        _c(
                          "VueCustomTooltip",
                          {
                            attrs: {
                              label: "Copied to Clipboard",
                              position: _vm.isMobile ? "is-left" : "is-top",
                              sticky: true,
                              active: _vm.tooltipActive
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "copy-icon",
                              attrs: { src: require("@/assets/copy-icon.png") }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              attrs: { type: "hidden", id: "redemption-code" },
                              domProps: { value: _vm.redemptionCode }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "21px" } }, [
                    _vm._v("Redeem this code at the app")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "13px" } }, [
                    _vm._v("Or")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "23px" } }, [
                    _vm._v("Share it via")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "social-item d-flex justify-content-between px-5",
                      staticStyle: { "margin-bottom": "28px" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "d-flex",
                          attrs: {
                            href:
                              "mailto:?subject=" +
                              encodeURI("MusicVerse Redemption Code") +
                              "&body=" +
                              _vm.getMessageShare,
                            target: _vm.isMobile ? "_self" : "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/mail-icon.png") }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "d-flex",
                          attrs: {
                            href: _vm.getFromApps
                              ? _vm.buildUrlShareExternal(
                                  "https://api.whatsapp.com/send?text=" +
                                    _vm.getMessageShare
                                )
                              : "https://api.whatsapp.com/send?phone=&text=" +
                                encodeURI(_vm.getMessageShare),
                            target: _vm.isMobile ? "_self" : "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/wa-icon.png") }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "d-flex",
                          attrs: {
                            href: _vm.getFromApps
                              ? _vm.buildUrlShareExternal(
                                  "https://line.me/R/msg/text/?" +
                                    _vm.getMessageShare
                                )
                              : "https://line.me/R/msg/text/?" +
                                encodeURI(_vm.getMessageShare),
                            target: _vm.isMobile ? "_self" : "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/line-icon.png") }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-block",
                      attrs: {
                        href: _vm.getFromApps
                          ? "musicverse://transaction_done"
                          : "/#/home"
                      }
                    },
                    [_vm._v("Continue")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4266dd39", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4266dd39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Success.vue
// module id = null
// module chunks = 